import { Flex, Checkbox, Text, Badge, Spacer } from '@chakra-ui/react'
import { FC } from 'react'

import useConciliation from '@hook/budget/user-conciliation'

import BudgetConciliationModalEdit from '@component/Modules/Budget/ModalEdit'

const SelectedTableBar: FC = () => {
  const { selecteds, data, handleSelectAll } = useConciliation()

  return (
    <Flex
      borderBottom="solid 1px"
      borderColor="gray.200"
      alignItems="center"
      justifyContent="space-between"
      borderTop="1px solid #e8e8e8"
      paddingY={2}
      paddingX={4}
    >
      <Flex alignItems="center">
        <Checkbox
          color="black"
          iconColor="blue.400"
          borderColor="gray.400"
          checked={selecteds.length === data.length}
          onChange={handleSelectAll}
        >
          Selecionar Tudo
        </Checkbox>
      </Flex>

      <Flex marginLeft={4} alignItems="center">
        <Badge
          h="16px"
          minW="16.5px"
          marginRight={2}
          ml="1"
          color="#4b64c9"
          border="1px solid #4b64c9"
          background="#c0d9ff"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {selecteds.length}
        </Badge>
        <Text color={'black'}>Itens Selecionados</Text>
      </Flex>

      <Spacer />
      <BudgetConciliationModalEdit />
    </Flex>
  )
}

export default SelectedTableBar
